// extracted by mini-css-extract-plugin
export default {"newsList":"index_newsList_kFiy0","lietitem":"index_lietitem_C-14r clearfix","title":"index_title_B110H"};